import { useEffect, useState, useCallback } from "react";

export function useNarration() {
  const supported = typeof window !== "undefined" && "speechSynthesis" in window;
  const [speaking, setSpeaking] = useState(false);
  const [rate, setRate] = useState(1);

  const stop = useCallback(() => {
    if (supported) window.speechSynthesis.cancel();
    setSpeaking(false);
  }, [supported]);

  const play = useCallback(
    (text: string, onPos?: (charIndex: number) => void) => {
      if (!supported) return;
      window.speechSynthesis.cancel();
      const u = new SpeechSynthesisUtterance(text);
      u.rate = rate;
      u.onboundary = (e) => onPos?.(e.charIndex);
      u.onend = () => { setSpeaking(false); onPos?.(-1); };
      u.onerror = () => { setSpeaking(false); onPos?.(-1); };
      setSpeaking(true);
      window.speechSynthesis.speak(u);
    },
    [rate, supported]
  );

  useEffect(() => () => { if (supported) window.speechSynthesis.cancel(); }, [supported]);
  return { supported, speaking, rate, setRate, play, stop };
}
